angular.module('zc.commonApi')

.factory "ProjectAdvertising", ($resource, $q, BaseProjectCrudService) ->
  class ProjectAdvertising extends BaseProjectCrudService

  new ProjectAdvertising(
    $resource
    $q
    "/api/projects/:projectId/advertisings/:id"
    "advertising"
    "advertisings"
  )





// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/advertising.service.coffee